import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducer";
import {
  ReservationState,
  setReservation as setReservationAction,
} from "../../redux/slices/ReservationSlice";

const useReservation = () => {
  const dispatch = useDispatch();

  const reservation = useSelector((state: RootState) => {
    const { Reservation } = state;

    return Reservation;
  });

  const setReservation = useCallback(
    (param: ReservationState) => {
      dispatch(setReservationAction(param));
    },
    [dispatch]
  );

  return { reservation, setReservation };
};

export default useReservation;
